<template>
  <div :disabled="is_loading" @click="onClick" class="widget_badget">
    <span>
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: "widget_badget",
  props: {},
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {
    onClick(e) {
      let vm = this;
      vm.$emit("click", e);
    },
  },
};
</script>
<style lang="scss" scoped>
.widget_badget {
  border-radius: 50%;
  border: none;
  font-style: bold !important;
  font-weight: 500;
  position: relative;
  cursor: pointer;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 14px;
  }
  &.outline {
    background: #fff;
    border-width: 1px;
    border-style: solid;
  }
}
</style>
